import './styles.scss'
import React, { useEffect, useRef, useState } from 'react'
import { I18n } from 'react-redux-i18n'

const ReadMoreText = ({ mode, children, lines, characters, height, customTextClassName, customButtonClassName, signatureButton, onClick }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [isHideAction, setIsHideAction] = useState(false)
  const textRef = useRef(null)

  useEffect(() => {
    if (mode === 'lines' && lines && textRef?.current) {
      textRef.current.clientHeight === textRef.current.scrollHeight
        ? setIsHideAction(true)
        : setIsHideAction(false)
    }

    if (mode === 'characters' && characters) {
      children?.length <= characters
        ? setIsHideAction(true)
        : setIsHideAction(false)
    }

    if (mode === 'container' && height && textRef?.current) {
      textRef.current.clientHeight <= height
        ? setIsHideAction(true)
        : setIsHideAction(false)
    }
  }, [textRef, children])

  const toggleExpansion = () => setIsExpanded(!isExpanded)

  return (
    <div className='read-more-text'>
      <div
        className='read-more-text__text-container'
        style={{
          maxHeight: !isExpanded ? `${height}px` : 'initial',
          overflow: !isExpanded ? 'hidden' : 'initial'
        }}
      >
        {mode === 'lines' && lines && children?.length && (
          <p
            ref={textRef}
            className={`read-more-text__text ${customTextClassName ? customTextClassName : ''}`}
            style={{ WebkitLineClamp: !isExpanded ? lines : null }}
            dangerouslySetInnerHTML={{ __html: children }}
          ></p>
        )}
        {mode === 'characters' && characters && children?.length && (
          !isExpanded ? (
            <p
              className={`read-more-text__text ${customTextClassName ? customTextClassName : ''}`}
              dangerouslySetInnerHTML={{ __html: `${children.substring(0, characters)}${children?.length > characters ? '...' : ''}` }}
            ></p>
          ) : (
            <p
              className={`read-more-text__text ${customTextClassName ? customTextClassName : ''}`}
              dangerouslySetInnerHTML={{ __html: children }}
            ></p>
          )
        )}
        {mode === 'container' && (
          <>
            <p
              ref={textRef}
              className={`read-more-text__text ${customTextClassName ? customTextClassName : ''}`}
              dangerouslySetInnerHTML={{ __html: children }}
            ></p>
            {!isHideAction && !isExpanded && (
              <div className='read-more-text__gradient-box'></div>
            )}
          </>
        )}
      </div>
      <div className='read-more-wrapper'>
        {!isHideAction && (
          <div className={`read-more-text__action ${customButtonClassName ? customButtonClassName : ''}`} onClick={onClick ? onClick : toggleExpansion}>
            {!isExpanded ? (
              <i className="fa fa-chevron-down"></i>
            ) : (
              <i className="fa fa-chevron-up"></i>
            )}
            <label>{!isExpanded ? I18n.t('text_see_more') : I18n.t('text_see_less')}</label>
          </div>
        )}
        {signatureButton && signatureButton()}
      </div>
    </div>
  )
}

export default ReadMoreText
